import { PoiIcon } from '@/components/Analysis/modules/pointOfInterest/PointOfInterestTab/PoiIcon';
import { SvgIcon } from '@mui/material';

export const EmptyStateIcon = ({ icon }: { icon: string }) => {
  return (
    <SvgIcon sx={{ height: '52px', width: '43px', color: 'white' }} viewBox="0 0 40 45">
      <path
        d="M25 39.9928C25 41.5724 21.578 45.0011 20 45.0011C18.422 45.0011 15 41.5727 15 39.993C15 38.4134 18.422 39.2807 20 39.2807C21.578 39.2807 25 38.4131 25 39.9928Z"
        fill="#BCC9D8"
      />
      <path
        opacity="0.8"
        d="M39.5 20.0215C39.5 30.8034 30.769 39.5429 20 39.5429C9.23095 39.5429 0.5 30.8034 0.5 20.0215C0.5 9.23955 9.23095 0.5 20 0.5C30.769 0.5 39.5 9.23955 39.5 20.0215Z"
        fill="#ADBDCF"
        stroke="#F1F1F1"
      />
      <g
        style={{
          transform: 'scale(0.65) translateY(-4px)',
          transformOrigin: 'center',
          marginBottom: '8px',
        }}
      >
        <PoiIcon name={icon} />
      </g>
    </SvgIcon>
  );
};
